// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500&display=swap);"]);
// Module
exports.push([module.id, "body {\n  overflow: auto;\n  background-color: #f5f5f5 !important; }\n\n::-webkit-scrollbar {\n  width: 10px; }\n\n::-webkit-scrollbar-track {\n  background: #e0e0e0; }\n\n::-webkit-scrollbar-thumb {\n  background-color: #b8b8b8;\n  border-radius: 25px; }\n\n::-webkit-scrollbar-thumb:hover {\n  background-color: #b9b9b9; }\n\n#zmmtg-root {\n  display: none; }\n", ""]);
// Exports
module.exports = exports;
